import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JobcardService } from '../../../../../services/jobcard.service';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '../../../../../app.config';
import { HelpersService } from '../../../../../services';

@Component({
  selector: 'app-workshop-jobcard-audit-trail',
  templateUrl: './workshop-jobcard-audit-trail.component.html',
  styleUrls: ['./workshop-jobcard-audit-trail.component.scss']
})
export class WorkshopJobcardAuditTrailComponent implements OnInit {
  @Input() jobcard: any;
  @Output() auditCount = new EventEmitter<number>();

  public displayDateTimeFormat: any = 'dd-MM-yyyy HH:mm';
  auditEntries: any[] = [];
  groupedEntries: { dateLabel: string; entries: any[] }[] = [];
  countryData: any = {};

  constructor(public activeModal: NgbActiveModal, private jobcardService: JobcardService,
    private translateService: TranslateService, public appConfig: AppConfig, public helpersService: HelpersService) { }

  ngOnInit(): void {
    console.log(this.jobcard);
    this.countryData = this.helpersService.getCountryData();
    this.displayDateTimeFormat = this.countryData.AngularDateFormat;
    this.jobcardService.getJobcardAudit(this.jobcard.partnerID, this.jobcard.id).subscribe(res => {
      console.log(res);
      res.forEach(entry => {
        var translation = this.getTranslationForEntry(entry);
        var date = new Date(new Date(entry.createdDate));
        var vdate = new Date(date.getTime() - new Date().getTimezoneOffset() * 60000).toISOString();
        this.auditEntries.push(
          {
            title: translation,
            actor: (entry.name + ' ' + entry.surname).trim(),
            timestamp: vdate
          }
        );
        console.log('Added entry:', entry);
      });
      this.auditCount.emit(this.auditEntries.length);
      this.groupEntriesByDate();
    });
  }

  private groupEntriesByDate(): void {
    const groups = new Map<string, any[]>();

    this.auditEntries.forEach(entry => {
      const key = this.formatDateKey(new Date(entry.timestamp));
      if (!groups.has(key)) {
        groups.set(key, []);
      }
      groups.get(key)!.push(entry);
    });

    this.groupedEntries = Array.from(groups.entries()).map(([dateLabel, entries]) => ({
      dateLabel,
      entries
    }));
  }

  private formatDateKey(date: Date): string {
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }

  formatEntryTime(timestamp: string): string {
    const date = new Date(timestamp);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  formatEntryDate(timestamp: string): string {
    const date = new Date(timestamp);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }

  print(): void {
    const win = window.open('', '_blank'); 
    if (!win) return;

    const groupsHtml = this.groupedEntries.map(group => {
      const entriesHtml = group.entries.map((entry, i, arr) => `
        <div class="audit-entry">
          <div class="audit-entry-title">${entry.title}</div>
          <div class="audit-entry-actor">${entry.actor}</div>
          <div class="audit-entry-time">${this.formatEntryTime(entry.timestamp)} &middot; ${this.formatEntryDate(entry.timestamp)}</div>
        </div>
        ${i < arr.length - 1 ? '<div class="audit-entry-divider"></div>' : ''}
      `).join('');
      return `<div class="audit-date-header">${group.dateLabel}</div>${entriesHtml}`;
    }).join('');

    win.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Audit Trail &mdash; #${this.jobcard?.jobCardNo}</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 32px; color: #1a1a2e; }
            h1 { font-size: 20px; font-weight: 600; margin: 0 0 4px 0; }
            .subtitle { font-size: 13px; color: #6b7280; margin-bottom: 24px; }
            .audit-date-header { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; color: #6b7280; padding: 16px 0 8px 0; }
            .audit-entry { padding: 12px 0; }
            .audit-entry-title { font-size: 14px; font-weight: 600; }
            .audit-entry-actor { font-size: 13px; color: #374151; margin-top: 2px; }
            .audit-entry-time { font-size: 12px; color: #9ca3af; margin-top: 2px; }
            .audit-entry-divider { height: 1px; background-color: #f3f4f6; }
          </style>
        </head>
        <body>
          <h1>Audit Trail &mdash; #${this.jobcard?.jobCardNo}</h1>
          <div class="subtitle">${this.jobcard?.customer?.Name ?? ''} ${this.jobcard?.customer?.Surname ?? ''} &middot; ${this.auditEntries.length} entries</div>
          ${groupsHtml}
          <script>window.onload = function() { window.print(); window.onafterprint = function() { window.close(); }; };<\/script>
        </body>
      </html>
    `);
    win.document.close();
  }

  private getTranslationForEntry(entry: any): string {
    switch (entry.type) {
      case "Service":
        switch (entry.property) {
          case "StatusID":
            var from = this.appConfig.getFullStatusList().find(status => status.key == entry.from)?.label;
            var to = this.appConfig.getFullStatusList().find(status => status.key == entry.to)?.label;
            return this.translateService.instant(entry.translation).replace("$From$", from).replace("$To$", to);
          case "CancellationReason":
            return this.translateService.instant(entry.translation).replace("$To$", entry.to);
        }   
        break;
      default:
        break;
    }
    return entry.translation;
  }
}
